<script lang="ts">
	import LegalOverview from '$lib/components/legal/legal-overview.svelte';
</script>

<LegalOverview />
